import React, { useMemo } from 'react';
import PartyLedgerPage from './PartyLedgerPage';
import { createLender, deleteLender, getLenders, updateLender } from '../api/lenderApi';

const LenderPage = () => {
  const introText = useMemo(
    () =>
      'Track each lending partner, the original funding they extended, and the purpose that capital serves for operations.',
    []
  );

  const apiClient = useMemo(
    () => ({
      fetchAll: getLenders,
      create: createLender,
      update: updateLender,
      remove: deleteLender
    }),
    []
  );

  return <PartyLedgerPage partyLabel="Lender" introText={introText} apiClient={apiClient} />;
};

export default LenderPage;
